module.exports = __webpack_public_path__ + "static/media/14-martonio-lima.8805d1e4.webp";